module.exports = __webpack_public_path__ + "img/MF-A136A-BS.33fa6d27.png";